import React from "react";
import { useNavigate } from "react-router-dom";
import { formatNotificationDate } from "../../utils/notification.util";
import styles from "./style.module.css";

function getContainerVariant(variant) {
  switch (variant) {
    case "rounded":
      return styles.roundedContainer;
    default:
      return styles.container;
  }
}

const NotificationCard = ({ notification, variant }) => {
  const navigate = useNavigate();

  function handleNotificationClick() {
    if (notification?.loanId) {
      navigate(`/my-loans/${notification?.loanId}`);
    }
    if (notification?.message?.includes("ข้อมูลส่วนตัว")) {
      navigate(`/profile`);
    }
  }

  return (
    <div
      className={`${getContainerVariant(variant)} ${
        notification?.isRead ? "" : styles.unread
      }`}
      onClick={handleNotificationClick}
    >
      <div className={styles.row}>
        <p className={styles.loanName}>{notification?.message}</p>
        {/* {notification?.loanInfo && (
          <div className={styles.status}>
            <div
              className={styles.statusCircle}
              style={{
                backgroundColor: getLoanStateColor(
                  notification?.loanInfo?.loan_state
                ),
              }}
            ></div>
            <p
              style={{
                color: getLoanStateColor(notification?.loanInfo?.loan_state),
              }}
            >
              {showLoanStatusMessage(notification?.loanInfo?.loan_state)}
            </p>
          </div>
        )} */}
      </div>
      <p className={styles.createdAt}>
        {formatNotificationDate(new Date(notification.createdAt))}
      </p>
    </div>
  );
};

export default NotificationCard;
